import { Box, Container, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Banner from "./Banner";
import Cards from "../../components/Card";
import CardDetalles from "./CardDetalles";
import BrandUrgencias from "./BrandUrgencias";
import BrandAseguradoras from "./BrandAseguradoras";
import BrandAmbulancia from "./BrandAmbulancia";
import Slide from "./Slide";
import BrandLeyenda from "./BrandLeyenda";
import CardEffects from "./CardEffects";
import SocialMedia from "./SocialMedia";
import TextToSpeech from "../../components/TextToSpeech";

import BannerPopup from "../../components/BannerPopup";
import {bannerPreRegistroDesktop,bannerPreRegistroMobile} from "../../data/data";

import { dataHome, itemsHome, itemsBannerHeroSlider} from "../../data/data";
import {ScrollMove, ScrollStatic} from "../../components/common/ScrollItem";
import cardPremium from "../../assets/Credenciales/Credencial_plan_premium_Salud_365.png";
import cardBasic from "../../assets/Credenciales/Credencial_plan_basico_Salud_365.png";

const Home = () => {
  const navigate = useNavigate();
  const accessibilityText = `
    Bienvenido al sitio web centro quirurgico san rafael.
    Aquí podrás encontrar información sobre los servicios que ofrecemos, planes, numeros de atención, directorios medicos y aseguradoras.
    Utiliza el menú principal para navegar por las diferentes secciones y adentrarte a los beneficios que tenemos para ti.
  `;

  return (
    <Box sx={{
      width: "100%",
      minHeight: "100%",
      backgroundSize: "100% 20%",
      backgroundRepeat: "no-repeat",
      //mb: { xs: "5px", sm: "10px" },
      overflow: "auto",
    }}>
      {/* --- CONTENEDOR PRINCIPAL ALL COMPONENTS --- */}
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
      }}>
        {/* --- HEADER --- */}
        <ScrollStatic>
          <Banner items={itemsBannerHeroSlider} />
        </ScrollStatic>

        {/* --- BANNER EMERGENTE --- */}
        <BannerPopup
          desktopImage={bannerPreRegistroDesktop}
          mobileImage={bannerPreRegistroMobile}
          storageKey="banner-pre-registro"
        />

        {/* CARDS 4 ITEMS   */}
        <ScrollMove>
          <Container sx={{
            width: "100%",
            display: "grid !important",
            placeItems: "center",
          }}> 
            <Grid container spacing={0} sx={{ margin: '20px 0px', justifyContent: "center"}}>
              {dataHome.map((item, index) => (
                <Cards
                  key={index}
                  titulo={item.titulo}
                  subtitulo={item.subtitulo}
                  url={item.url}
                  image={item.image}
                  onClick={() => navigate(item.url)}
                />
              ))}
            </Grid>
          </Container>
        </ScrollMove> 

        <TextToSpeech text={accessibilityText} />

        {/* CARD EFFECTS STARS ----   */}
        {/* <ScrollMove>
          <CardEffects imageBasicCard={cardBasic} imagePremiumCard={cardPremium} />
        </ScrollMove> */}

        {/* IMAGEN MAS TEXTO   */}
        <ScrollMove>
          <BrandLeyenda />
        </ScrollMove>

        {/* DETALLES ICONOS 6 */}
        <ScrollMove>
          <CardDetalles />
        </ScrollMove>

        {/* RED SOCIAL ----   */}
        <ScrollMove>
          <SocialMedia />
        </ScrollMove>

        {/* --- SLIDER 3 FOTOS --- */}
        <ScrollMove>
          <Container sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}>
            <Slide items={itemsHome} />
          </Container>
        </ScrollMove>

        {/* --- AMBULANCIA COMPONENT --- */}
        <ScrollMove>
          <BrandAmbulancia />
        </ScrollMove>

        {/* --- URGENCIAS COMPONENT --- */}
        <ScrollMove>
          <BrandUrgencias />
        </ScrollMove>

        {/* --- ASEGURADORAS COMPONENT --- */}
        <ScrollStatic>
          <BrandAseguradoras />
        </ScrollStatic>

      </Container>
    </Box>
  );
};

export default Home;
